import {
  Building2,
  Store,
  Stethoscope,
  SprayCan,
  Droplets,
  Wind,
  Recycle,
  Truck,
  ClipboardList,
} from "lucide-react";

export const BRAND = {
  name: "OCD",
  full: "OCD — Entretien Cleaning",
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_pro-cleaning-site-3/artifacts/qr0aq320_logo%20ocd.png",
  slogan: "Professional. Reliable. Spotless.",
  contactPerson: "Jumain Daly",
  phone: "514-977-5937",
  blue: "#1478FF",
};

export const CONTACTS = [
  { roleKey: "ceo", name: "Jumain Daly", phone: "514-977-5937" },
];

export const EMAIL = "entretienocdcleaning@gmail.com";

export const SERVICES = [
  { icon: Building2, title: "Office Cleaning", desc: "Pristine, professional workspaces that keep teams focused.", span: "lg:col-span-6", tall: true },
  { icon: Store, title: "Retail & Commercial", desc: "Spotless spaces that impress every customer.", span: "lg:col-span-3" },
  { icon: Stethoscope, title: "Medical Offices", desc: "Hospital-grade sanitization protocols.", span: "lg:col-span-3" },
  { icon: SprayCan, title: "Floor Care", desc: "Stripping, waxing & long-term maintenance.", span: "lg:col-span-4" },
  { icon: Droplets, title: "Restroom Sanitization", desc: "Thorough, deep disinfection.", span: "lg:col-span-4" },
  { icon: Wind, title: "Dusting & Disinfecting", desc: "Every surface, every fine detail.", span: "lg:col-span-4" },
  { icon: Recycle, title: "Waste Removal", desc: "Garbage & recycling, on schedule.", span: "lg:col-span-4" },
  { icon: Truck, title: "Move-In / Move-Out", desc: "Complete turnover cleaning.", span: "lg:col-span-4" },
  { icon: ClipboardList, title: "Custom Plans", desc: "Built precisely around your budget.", span: "lg:col-span-4" },
];

export const WHY = [
  { t: "Reliable & Trustworthy", d: "We show up, every time, and treat your space like our own." },
  { t: "Attention to Detail", d: "The corners others miss are where we begin." },
  { t: "Flexible Scheduling", d: "Day, night or weekend — we work around your operation." },
  { t: "Competitive Pricing", d: "Premium results without the premium runaround." },
  { t: "Customer Satisfaction", d: "A finish you can see, feel and trust." },
  { t: "Professional & Friendly", d: "A vetted, courteous team you'll be glad to have around." },
];

export const MARQUEE_WORDS = [
  "Professional",
  "Reliable",
  "Spotless",
  "OCD Entretien",
  "Commercial",
  "Sanitized",
];
